import React, { useContext, useMemo } from "react";
import { FilterBar } from "@sscs/ui";
import { BehaviorCategoryFilter, BehaviorDescriptionFilter, PrevalenceFilter, } from "../../common";
import { ReportContext } from "../../context";
import { useLazyGetBehaviorCategoriesQuery, useLazyGetBehaviorDescriptionsQuery, } from "../../services/behavior.api";
const BehaviourFilter = ({ filter, onFilterChange, }) => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const [getDescriptions, { data: descriptions, isFetching: isDescriptionsFetching },] = useLazyGetBehaviorDescriptionsQuery();
    const [getCategories, { data: categories, isFetching: isCategoriesFetching },] = useLazyGetBehaviorCategoriesQuery();
    const descriptionOptions = useMemo(() => (descriptions ? descriptions.map((item) => item.value) : []), [descriptions]);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "description",
                minWidth: "280px",
                grow: 2,
                control: (React.createElement(BehaviorDescriptionFilter, { loading: isDescriptionsFetching, description: filter.description, descriptionOptions: descriptionOptions, onOpen: () => getDescriptions({ ui_id: reportId }), onChange: (value) => {
                        onFilterChange({
                            ...filter,
                            description: value,
                        });
                    } })),
            },
            {
                id: "prevalence",
                grow: 0,
                control: (React.createElement(PrevalenceFilter, { prevalence: filter.prevalence, onChange: (value) => onFilterChange({
                        ...filter,
                        prevalence: value,
                    }) })),
            },
            {
                id: "category",
                width: "210px",
                control: (React.createElement(BehaviorCategoryFilter, { category: filter.category, categoryOptions: (_a = categories === null || categories === void 0 ? void 0 : categories.categories) !== null && _a !== void 0 ? _a : [], loading: isCategoriesFetching, onOpen: () => getCategories({ ui_id: reportId }), onChange: (value) => {
                        onFilterChange({
                            ...filter,
                            category: value,
                        });
                    } })),
            },
        ] }));
};
export default BehaviourFilter;
//# sourceMappingURL=BehaviourFilter.js.map